import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { Dialog } from 'react-toolbox';
import styles from 'styles/input.scss';
import StyledSelect from 'components/StyledSelect';
import ConfirmDialog from 'components/ConfirmDialog';
import TextArea from 'components/TextArea';
import S from 'modal.scss';
import { deletePhaseAppointment } from 'actionCreators/appointments';
import { getPhaseErrors } from '../../../../../../../../reducers';
import { vendorDisplayName, vendorLowes } from '../../../../../../../../utils';

const DEFAULT_STATE = {
  who: '',
  reason: '',
  showConfirm: false,
  errors: {},
};

class DeleteAppointmentModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = DEFAULT_STATE;
  }

  handleWhoChange = e => this.setState({ who: e });

  handleReasonChange = e => this.setState({ reason: e.target.value });

  handleSubmit = () => {
    const { who, reason } = this.state;
    const errors = {};
    if (who.trim() === '') errors.who = 'Can\'t be blank.';
    if (reason.trim() === '') errors.reason = 'Can\'t be blank.';
    this.setState({ errors, showConfirm: !(errors.who || errors.reason) });
  }

  handleClose = () => {
    this.setState(DEFAULT_STATE);
    this.props.onClose();
  }

  handleConfirmSubmit = () => {
    const appt = this.props.appointment;
    const { who, reason } = this.state;
    const eventProps = { who, note: reason };
    this.props.deletePhaseAppointment(appt.id, eventProps).then(() => this.handleClose());
  }

  handleConfirmClose = () => this.handleClose();

  // Until we make PFT its own vendor, we have to make special consideration
  // TODO: Remove this function when PFT is a vendor
  options = () => {
    const { phaseSource, phaseWorkroom } = this.props;
    const vendorOption = vendorDisplayName(phaseSource, phaseWorkroom);
    const isVendorLowes = vendorLowes(phaseSource);
    const baseOptions = [
      'Customer',
      ...(phaseSource === 'IFI' ? [] : ['SPIG']),
      vendorOption,
    ];
    if (vendorOption !== 'Lowe\'s' && isVendorLowes) baseOptions.push('Lowe\'s');
    return (vendorOption !== 'Refloor' ?
      baseOptions :
      [...baseOptions, vendorDisplayName('PFT', null, true)])
      .map(o => ({ value: o, label: o }));
  }

  render = () => {
    const { active, serverErrors } = this.props;
    const { who, reason, showConfirm, errors } = this.state;
    return (<Dialog
      active={active}
      className={S.modal}
      type="fullscreen"
      onEscKeyDown={this.handleClose}
      onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton
        icon="close"
        className={S.close}
        onClick={this.handleClose}
        tabIndex={-1}
      />
      <h5 className={S.title}>Delete Appointment</h5>
      <StyledSelect
        className={S.select}
        label="Who is deleting? *"
        onChange={this.handleWhoChange}
        options={this.options()}
        value={who}
        placeholder={'Select'}
        error={errors.who}
      />
      <TextArea
        label="Reason *"
        value={reason}
        errors={[errors.reason]}
        onChange={this.handleReasonChange}
      />
      <Button
        label="Delete Appointment"
        flat inverse ripple
        className={S.submit}
        onClick={this.handleSubmit}
      />
      <ConfirmDialog
        title="Are you sure you want to delete this appointment?"
        okLabel="Yes, Delete the Appointment"
        cancelLabel="No"
        show={showConfirm}
        cancel={this.handleConfirmClose}
        dismiss={this.handleConfirmClose}
        proceed={this.handleConfirmSubmit}
      />
    </Dialog>);
  }
}

DeleteAppointmentModal.propTypes = {
  active: PropTypes.bool.isRequired,
  deletePhaseAppointment: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  appointment: PropTypes.object,
  serverErrors: PropTypes.shape({}),
  phaseSource: PropTypes.string,
  phaseWorkroom: PropTypes.string,
};

DeleteAppointmentModal.defaultProps = { active: false };

export default connect(
  state => ({ serverErrors: getPhaseErrors(state) }),
  { deletePhaseAppointment },
)(DeleteAppointmentModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAppointments/components/deleteAppointmentModal.jsx